import axios from "@/app/Axios";
class reservas {
    async saveReservas(data) {
        try {
            console.log("Respuesta de Servicio ",data);
          const response = await axios.post("/post_reservas", data);
          console.log("Respuesta de Servicio ",response);
          return response.data;
        } catch (error) {
          console.log(error);
        }
      }
      async cancelarReserva(data) {
        try {
            console.log("Respuesta de Servicio ",data);
          const response = await axios.post("/reservas/cancelar", data);
          console.log("Respuesta de Servicio ",response);
          return response.data;
        } catch (error) {
          console.log(error);
        }
      }
      async cancelarReservaMesa(data) {
        try {
            console.log("Respuesta de Servicio ",data);
          const response = await axios.post("/reservas/cancelar-mesa", data);
          console.log("Respuesta de Servicio ",response);
          return response.data;
        } catch (error) {
          console.log(error);
        }
      }

  async getUsuarios() {
    try {
      const response = await axios.get("/usuario");
      return response.data;
    } catch (error) {
      console.log(error);
      return { status: false, message: "Error interno del servidor" };
    }
  }
  async saveUsuarios(data) {
    try {
        console.log("Respuesta de Servicio ",data);
      const response = await axios.post("/register", data);
      console.log("Respuesta de Servicio ",response);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUsuarios(id, data) {
    try {
        const response = await axios.put(`/usuarioupdate/${id}`, data);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            return error.response.data;
        } else {
            console.log(error);
        }
    }
}
async ver_silla_reserva_mesa(id,id2) {
  try {
      const response = await axios.get(`/mostrar_reserva_activa/${id}/${id2}`);
      return response.data;
  } catch (error) {
      if (error.response && error.response.status === 401) {
          return error.response.data;
      } else {
          console.log(error);
      }
  }
}
async getDatosUserLogued() {
  try {
    const response = await axios.get("/mostrar_datos_user");
    console.log("Respuesta de Servicio actividades", response);
    return response.data;
  } catch (error) {
    console.log(error);
    return { status: false, message: "Error interno del servidor" };
  }
}
  async destroyusuarios(id) {
    try {
      const response = await axios.delete(`/usuariodelete/${id}`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return error.response.data;
      } else {
        console.log(error);
      }
    }
  }
      async getDetalleReservas() {
        try {
            const response = await axios.get("/detalle");
            return response.data;
        } catch (error) {
            console.log(error);
            return { status: false, message: "Error al obtener el detalle de reservas" };
        }
    }
    async existe_reserva_mesa(id,id2,id3) {
      try {
          const response = await axios.get(`/reserva_existe/${id}/${id2}/${id3}`);
          return response.data;
      } catch (error) {
          console.log(error);
          return { status: false, message: "Error al obtener el detalle de reservas" };
      }
  }
}
export default reservas;
